import React, { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';

import { QUERY_KEYS, ROUTES } from '../../../constants';
import { popup } from '../../../utils';
import { HideIcon } from '../../../assets/svg/HideIcon';
import { CircleSpinner, Documents } from '../../../assets/svg';
import { hideHiringClients } from '../../../utils/apiServices/hideHiringClientApi';
import { ConfirmationBox } from '../../shared';

const HiringClientsActions = ({ id, name }) => {
    const queryClient = useQueryClient();
    const [confirm, setConfirm] = useState(false);
    const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
    const isUserPrimary = useSelector((s) => s.accountArray?.isUserPrimary);
    const selectedAccount = useSelector((s) => s.accountArray?.selectedAccount);
    const selectedAccountName = useSelector((s) => s.accountArray?.selectedAccountName);
    const navigate = useNavigate();

    const hideHcMutation = useMutation({
        mutationFn: async () =>
            await hideHiringClients({
                accountId: selectedAccount,
                hiringClientIds: id,
            }),
        onSuccess: () => {
            setOpenConfirmationBox(false);
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.HIRING_CLIENTS, selectedAccount],
            });
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.HIDDEN_HIRING_CLIENTS, selectedAccount],
            });
            popup('success', `${name} has been hidden for ${selectedAccountName}.`);
        },
        onError: (error) => {
            popup('error', error.message);
        },
    });

    const hideHiringClient = async () => {
        if (!isEmpty(selectedAccount) && id) {
            hideHcMutation.mutate();
        } else {
            popup('error', 'You are not a primary user!');
        }
    };

    useEffect(() => {
        if (confirm && isUserPrimary) {
            hideHiringClient();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirm, isUserPrimary]);

    return (
        <div className='d-flex gap-3 justify-content-center align-items-center'>
            <span
                id='action-btn'
                title='Go to Document'
                onClick={() => {
                    navigate(ROUTES.CUSTOMER.DOCUMENTS, {
                        state: {
                            hiringClientId: id,
                        },
                    });
                }}
            >
                <Documents />
            </span>
            {isUserPrimary ? (
                <span
                    id='action-btn'
                    title='Hide Hiring Client'
                    aria-label='Hide Hiring Client'
                    onClick={() => setOpenConfirmationBox(true)}
                >
                    {hideHcMutation.isPending ? <CircleSpinner /> : <HideIcon />}
                </span>
            ) : null}
            {openConfirmationBox && (
                <ConfirmationBox
                    setConfirm={setConfirm}
                    openConfirmationBox={openConfirmationBox}
                    setOpenConfirmationBox={setOpenConfirmationBox}
                    customMessage={
                        <>
                            Do you want to hide <b>{name}</b>?
                        </>
                    }
                />
            )}
        </div>
    );
};

export default HiringClientsActions;
